<template>
        <el-dialog title="Users" :visible.sync="showPopup" class="my-dialog-class" >
        <el-form label-position="top" :inline="false" :rules="rules" label-width="100%"  :model='selectedObject'  ref='my-form' @submit.prevent="save" v-loading="loadingVisible" >
            <el-row :gutter="15" >
                
            <el-col :md='8'>
                <el-form-item label='FirstName' >
                    <el-input  class='full-width' v-model='selectedObject.FirstName' />
                </el-form-item>
            </el-col>
            <el-col :md='8'>
                <el-form-item label='LastName' >
                    <el-input  class='full-width' v-model='selectedObject.LastName' />
                </el-form-item>
            </el-col>
            <el-col :md='8'>
                <el-form-item label='Email' >
                    <el-input  class='full-width' v-model='selectedObject.Email' />
                </el-form-item>
            </el-col>
            <el-col :md='8'>
                <el-form-item label='PhoneNumber' >
                    <el-input  class='full-width' v-model='selectedObject.PhoneNumber' />
                </el-form-item>
            </el-col>
            <el-col :md='8'>
                <el-form-item label='DateOfBirth' >
                    <el-date-picker  class='full-width' v-model='selectedObject.DateOfBirth' type='date' value-format='yyyy-MM-dd' format='dd.MM.yyyy' />
                </el-form-item>
            </el-col>
            </el-row>
            <el-row>
            <el-col :md='8'>
                <el-form-item  >
                    <el-checkbox v-model='selectedObject.Notifications_Email_Updates' true-label='1' false-label='0'> Notifications Email Updates </el-checkbox>
                </el-form-item>
            </el-col>
            <el-col :md='8'>
                <el-form-item >
                    <el-checkbox v-model='selectedObject.Notifications_Email_Promotions' true-label='1' false-label='0'> Notifications Email Promotions </el-checkbox>
                </el-form-item>
            </el-col>
            <el-col :md='8'>
                <el-form-item >
                    <el-checkbox v-model='selectedObject.Notifications_Push_Confirmations' true-label='1' false-label='0'> Notifications Push Confirmations </el-checkbox>
                </el-form-item>
            </el-col>
            <el-col :md='8'>
                <el-form-item >
                    <el-checkbox v-model='selectedObject.Notifications_Push_Changes' true-label='1' false-label='0'> Notifications Push Changes </el-checkbox>
                </el-form-item>
            </el-col>
            <el-col :md='8'>
                <el-form-item >
                    <el-checkbox v-model='selectedObject.Notifications_Push_Reminders' true-label='1' false-label='0'> Notifications Push Reminders </el-checkbox>
                </el-form-item>
            </el-col>            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer" >
            <el-button @click="showPopup=false"     > Renunta  </el-button>
            <el-button type="primary" @click="save" > Salveaza </el-button>
        </span>
    </el-dialog>
</template>

<script>
    import settings from "@/backend/LocalSettings";
    import BasePage from '@/pages/BasePage';

    export default {
        name: "Users_dialog",
        extends: BasePage,
        data () {
            return {
                baseUrl :'',
                showPopup: false,
                mode: 'add',
                selectedObject: {
                    FirstName: '' , LastName: '' , Email: '' , PhoneNumber: '' , DateOfBirth: '' , Notifications_Email_Updates: '' , Notifications_Email_Promotions: '' , Notifications_Push_Confirmations: '' , Notifications_Push_Changes: '' , Notifications_Push_Reminders: '' ,                 },
                Info:{
                                    },
                rules: {
                    //   Nume: [ { required: true, message: "Campul este obligatoriu" } ]
                    FirstName: [ { required: true, message: 'Campul este obligatoriu' } ], 
LastName: [ { required: true, message: 'Campul este obligatoriu' } ], 
Email: [ { required: true, message: 'Campul este obligatoriu' } ], 
PhoneNumber: [ { required: true, message: 'Campul este obligatoriu' } ], 
DateOfBirth: [ { required: true, message: 'Campul este obligatoriu' } ], 
Notifications_Email_Updates: [ { required: true, message: 'Campul este obligatoriu' } ], 
Notifications_Email_Promotions: [ { required: true, message: 'Campul este obligatoriu' } ], 
Notifications_Push_Confirmations: [ { required: true, message: 'Campul este obligatoriu' } ], 
Notifications_Push_Changes: [ { required: true, message: 'Campul este obligatoriu' } ], 
Notifications_Push_Reminders: [ { required: true, message: 'Campul este obligatoriu' } ], 
                }
            }
        },
        methods: {
            show_me: async function( id ) {
                this.showPopup        = true;
                if( id == null )
                {
                    this.mode = "add";
                }
                else
                {
                    this.mode             = "edit";
                    var            result = await this.post("users/get_info_item_dialog", { id: id } );
                    this.selectedObject   = result.Item;
                }
            },
            async get_info(){
                var response = await this.post("users/get_info_for_dialog" );
                            },
                        save: async function() {
                this.$refs['my-form'].validate( async(valid) => {
                    if (valid)
                    {
                        await this.post("users/save", { mode: this.mode, object: this.selectedObject } );
                        this.showPopup = false;
                        this.$emit("save");
                    }
                });
            }
        },
        mounted: function() {
            this.baseUrl = settings.BASE_URL;
            this.get_info();
        }
    };
</script>

<style lang="less" scoped>
    .full-width {
        width: 100%;
    }

</style>